;
define("store_locator_main.tpl", function(){});

